import { useMutation } from '@tanstack/react-query';

import { paymentRepo } from '@ctct/domain-layer';

import { useMutationMemoized } from '../helpers/useMutationMemoized';

export const useCreateAmazonPaySignature = () => {
  const mutation = useMutation({
    mutationFn: paymentRepo.createAmazonPaySignature,
  });

  return useMutationMemoized(mutation);
};

export type CreateAmazonPaySignatureMutation = ReturnType<typeof useCreateAmazonPaySignature>;
